<template>
  <div class="width">
    <div class="box">
      <router-link tag="div" class="nav-item" to="/orders/list/my"
        ><span>주문내역</span></router-link
      >
      <router-link
        tag="div"
        class="nav-item"
        to="/orders/list/member?p=1"
        v-show="isManager"
        ><span>구성원 주문내역</span></router-link
      >
    </div>

    <router-view />
  </div>
</template>
<style src="./layout.css" scoped></style>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    isManager() {
      if (this.$store.getters["auth/tokenPayload"]().type === "manager")
        return true;
      return false;
    }
  }
};
</script>
<style src="./layout.css" scoped></style>
